// @core/api/endpoints/workflow/list_environments.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEnvironmentsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List environments
 * Returns all environments for a pipeline.
 */
export async function ListEnvironments(
  pipeline_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListEnvironmentsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/environments`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.get<ListEnvironmentsResponse>(requestPath, { ...requestOptions, params });
}
